<!--  -->
<template>
  <div class="app-content">
    <div class="hint-area">
      <div class="hint-context">
        <div class="hint-title">添加牌位</div>
        <div class="hint-word">请注意，所有祭主必须为同一辈分</div>
      </div>
    </div>
    <div class="info-area">
      <div class="info-item">
        <div class="cell-area">
          <div class="cell-title">亡人信息</div>
          <img @click="deleteInfo"
               src="../assets/delete.png"
               class="icon-delete">
          <div class="cell"
               style="border: none;">
            <van-field v-model="soulType"
                       label-align="left"
                       label="超度类别"
                       placeholder="请选择"
                       readonly="readonly"
                       @click="shichen=true" />
            <img src="../assets/jiantouyou.png"
                 class="choose-arrow">
          </div>
          <div class="cell">
            <van-field v-model="surName"
                       label-align="left"
                       label="被超度人"
                       placeholder="请输入姓氏" />
          </div>
          <div class="cell-alive-title"
               style="">祭主(阳上)信息</div>
          <div class="cell-alive-list">
            <van-field v-model="surName1"
                       label-align="left"
                       label="祭主1"
                       placeholder="请输入祭主姓名" />
            <van-field v-model="surName2"
                       label-align="left"
                       label="祭主2"
                       placeholder="请输入祭主姓名" />
            <van-field v-model="surName3"
                       label-align="left"
                       label="祭主3"
                       placeholder="请输入祭主姓名" />
            <van-field v-model="surName4"
                       label-align="left"
                       label="祭主4"
                       placeholder="请输入祭主姓名" />
          </div>

          <div class="bottom-area">
            <img src="../assets/shouqijiantou.png"
                 style="width: 16px; height: 16px; margin-top: 7px; margin-left: calc(-35px + 50vw);">
            <div style="margin-left: 2px;">收起</div>
          </div>
        </div>
      </div>
    </div>
    <div class="add-more">新增更多牌位</div>
    <div class="money-container">
      <div class="money-title">功德经资<span class="price-type">按牌位单价</span></div>
      <div class="money-select-block">
        <div class="money-item-wrap">
          <div class="money-item money-item-selected">
            100
          </div>
        </div>
        <div class="money-item-wrap">
          <div class="money-item">
            300
          </div>
        </div>
      </div>
      <div class="cell">
        <div class="label">功德经资</div>
        <div class="label"
             style="flex: 1 1 0%; display: flex; align-items: center;">
          <div class="buyer-info-input"
               style="margin-left: 20px; line-height: 20px; color: rgba(0, 0, 0, 0.6);">
            外坛小牌位 100元/牌位
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="money-container" v-if="this.meetingInfo?.name.includes("拜太岁")">
      <div class="label"
           style="display:flex;margin-bottom:10px;font-weight: 600">邮寄到家(到付)</div>
      <van-radio-group v-model="isYj"
                       direction="horizontal"
                       @change="onRadioChange">
        <van-radio name="0">不邮寄</van-radio>
        <van-radio name="1">邮寄</van-radio>
      </van-radio-group>
    </div> -->
    <div style="width: 100%; height: 90px;"></div>
    <div class="bottom-container">
      <div class="money-detail-wrap"
           style="display: flex;">
        <div class="money-wrap">
          <span class="symbol">¥</span>
          <span class="money">100</span>
        </div>
        <div class="detail-wrap"
             @click="showPriceDetail =!showPriceDetail">
          <span class="detail-text">明细</span>
          <img src="../assets/mingxijiantou.png"
               alt="arrow-down"
               class="order-price-fold">
        </div>
      </div>
      <div class="submit-order">下一步</div>
    </div>
    <div class="price-detail-mask"
         style="display: none;"></div>
    <van-popup v-model="showPriceDetail"
               position="bottom"
               round>
      <img src="../assets/close.png"
           alt="close"
           @click="showPriceDetail = false">
      <div class="detail-title">价格明细</div>
      <div class="cell">
        <div class="title">功德经资</div>
        <div class="money">¥100</div>
      </div>
    </van-popup>
    <div class="mint-popup mint-popup-bottom"
         style="display: none;">
      <div class="picker">
        <div class="picker-toolbar">
          <div class="mint-datetime-action mint-datetime-cancel">取消</div>
          <div class="mint-datetime-action mint-datetime-confirm">确定</div>
        </div>
        <div class="picker-items">
          <div class="picker-slot picker-slot-center">
            <div class="picker-slot-wrapper"
                 style="height: 180px; transform: translate(0px, 72px) translateZ(0px);">
              <div class="picker-item picker-selected"
                   style="height: 36px; line-height: 36px;">
                无祀孤魂
              </div>
            </div>
          </div>
          <div class="picker-center-highlight"
               style="height: 36px; margin-top: -18px;"></div>
        </div>
      </div>
    </div>
    <div class="mint-popup mint-popup-bottom"
         style="display: none;">
      <div class="picker">
        <div class="picker-toolbar">
          <div class="mint-datetime-action mint-datetime-cancel">取消</div>
          <div class="mint-datetime-action mint-datetime-confirm">确定</div>
        </div>
        <div class="picker-items">
          <div class="picker-slot picker-slot-center">
            <div class="picker-slot-wrapper"
                 style="height: 180px; transform: translate(0px, 0px) translateZ(0px);"></div>
          </div>
          <div class="picker-center-highlight"
               style="height: 36px; margin-top: -18px;"></div>
        </div>
      </div>
    </div>
    <div class="mint-popup mint-popup-bottom"
         style="display: none;">
      <div class="picker">
        <div class="picker-toolbar">
          <div class="mint-datetime-action mint-datetime-cancel">取消</div>
          <div class="mint-datetime-action mint-datetime-confirm">确定</div>
        </div>
        <div class="picker-items">
          <div class="picker-slot picker-slot-center">
            <div class="picker-slot-wrapper"
                 style="height: 180px; transform: translate(0px, 72px) translateZ(0px);">
              <div class="picker-item picker-selected"
                   style="height: 36px; line-height: 36px;">
                外坛小牌位
              </div>
              <div class="picker-item"
                   style="height: 36px; line-height: 36px;">
                主坛大牌位
              </div>
            </div>
          </div>
          <div class="picker-center-highlight"
               style="height: 36px; margin-top: -18px;"></div>
        </div>
      </div>
    </div>
    <div id="moveDiv"
         class="btn-home"
         @click="goHome">
      <img src="../assets/shouye.png"
           class="img-home">
      <div class="text-home">首页</div>
    </div>
    <van-popup v-model="shichen"
               position="bottom"
               round>
      <van-picker class="danxiang-style"
                  show-toolbar
                  :columns="userState"
                  value-key="value"
                  v-model="soulType"
                  type="date"
                  title=""
                  @confirm="onConfirm"
                  @cancel="onCancel"
                  @change="onChange" />
    </van-popup>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      isYj: "0",
      surName1: "",
      surName2: "",
      surName3: "",
      surName4: "",
      surName: "",
      soulType: "",
      shichen: false,
      userState: [
        { label: "*氏门中历代宗亲", value: "*氏门中历代宗亲" },
        { label: "应生未生*氏之位(女方姓氏)", value: "应生未生*氏之位(女方姓氏)" },
        { label: "冤亲债主", value: "冤亲债主" },
        { label: "普利十方", value: "普利十方" },
        { label: "无祀十方孤魂", value: "无祀十方孤魂" },
        { label: "先曾祖父、先曾祖母", value: "先曾祖父、先曾祖母" },
        { label: "先曾伯父、先曾伯母", value: "先曾伯父、先曾伯母" },
        { label: "先曾叔父、先曾叔母", value: "先曾叔父、先曾叔母" },
        { label: "外曾祖父、外曾祖母", value: "外曾祖父、外曾祖母" },
        { label: "外曾伯父、外曾伯母", value: "外曾伯父、外曾伯母" },
        { label: "外曾叔父、外曾叔母", value: "外曾叔父、外曾叔母" },
        { label: "先祖父、先祖母", value: "先祖父、先祖母" },
        { label: "先伯祖父、先伯祖母", value: "先伯祖父、先伯祖母" },
        { label: "外祖父、外祖母", value: "外祖父、外祖母" },
        { label: "外伯祖父、外伯祖母", value: "外伯祖父、外伯祖母" },
        { label: "外叔祖父、外叔祖母", value: "外叔祖父、外叔祖母" },
        { label: "父亲、母亲", value: "父亲、母亲" },
        { label: "伯父、伯母", value: "伯父、伯母" },
        { label: "叔父、叔母", value: "叔父、叔母" },
        { label: "舅舅、舅妈", value: "舅舅、舅妈" },
        { label: "姨夫、姨妈", value: "姨夫、姨妈" },
        { label: "姑父、姑妈", value: "姑父、姑妈" },
        { label: "妻子", value: "妻子" },
        { label: "丈夫", value: "丈夫" },
        { label: "儿子", value: "儿子" },
        { label: "女儿", value: "女儿" },
        { label: "儿媳", value: "儿媳" },
        { label: "女婿", value: "女婿" },
        { label: "哥哥", value: "哥哥" },
        { label: "弟弟", value: "弟弟" },
        { label: "姐姐", value: "姐姐" },
        { label: "妹妹", value: "妹妹" },
        { label: "侄子", value: "侄子" },
        { label: "侄女", value: "侄女" },
        { label: "外甥", value: "外甥" },
        { label: "外甥女", value: "外甥女" },
        { label: "孙子", value: "孙子" },
        { label: "孙女", value: "孙女" },
        { label: "外孙", value: "外孙" },
        { label: "外孙女", value: "外孙女" }
      ],
      showPriceDetail: false,
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    onRadioChange(value) {
      console.log(`Selected value: ${value}`);
      localStorage.setItem('isYj', value);
    },
    onConfirm() {

    },
    goHome() {
      this.$router.push("/")
    },
    deleteInfo() {
      // 处理删除信息的逻辑
    },
    closePriceDetail() {
      // 处理关闭价格明细的逻辑
    },
    onCancel(date) {
      this.showPriceDetail = false
      this.shichen = false
    },
    onChange() {

    },
  },
  // 生命周期-创建完成（可以访问当前this实例）
  created() {
    localStorage.setItem("isYj", '0');
  },
  // 生命周期-挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期-创建之前
  beforeMount() { }, // 生命周期-挂载之前
  beforeUpdate() { }, // 生命周期-更新之前
  updated() { }, // 生命周期-更新之后
  beforeDestroy() { }, // 生命周期-销毁之前
  destroyed() { }, // 生命周期-销毁完成
  activated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
/* 头部样式 */
.app-content {
  height: 100%;
  width: 100%;
  padding-bottom: 82px;
}
.hint-area {
  width: 100%;
  height: 136px;
  background: linear-gradient(133deg, #007aaa, #004e93);
  z-index: 1;
}
.hint-context {
  width: calc(100vw - 24px);
  height: 85px;
  background: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 5;
  position: absolute;
  top: 16px;
  left: 12px;
}
.hint-title {
  width: 100px;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000;
  line-height: 25px;
  text-align: left;
  position: absolute;
  top: 16px;
  left: 12px;
}
.hint-word {
  width: 250px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  line-height: 20px;
  text-align: left;
  position: absolute;
  top: 49px;
  left: 12px;
}

/* 亡人信息卡片样式************* */
::v-deep .van-picker__toolbar {
  border-bottom: 1px solid #eaeaea;
  height: 45px;
}
::v-deep .van-picker__toolbar button {
  width: auto;
  line-height: 45px;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #007aaa;
  font-weight: 400;
}
::v-deep
  .danxiang-style.van-picker
  .van-picker__columns
  .van-picker-column
  ul
  .van-picker-column__item--selected
  .van-ellipsis {
  padding: 2px 10px;
  font-family: PingFangSC-Semibold;
  font-size: 20px;
  color: #007aaa;
  font-weight: 600;
}

.info-area {
  width: 100%;
  position: relative;
  top: -32px;
}
.info-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  top: -16px;
  margin-top: 16px;
}
.cell-area {
  width: calc(100vw - 24px);
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  background: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  position: relative;
  top: 16px;
  left: 12px;
}
.cell-title {
  width: 64px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000;
  line-height: 22px;
  position: relative;
  top: 16px;
  left: 12px;
}
.icon-delete {
  width: 16px;
  height: 16px;
  position: relative;
  top: -4px;
  left: calc(100vw - 52px);
}

.cell-area .cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 0 14px;
  padding: 14px 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 48px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.cell-area .cell .title {
  width: 60px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}
.color-gray {
  color: rgba(0, 0, 0, 0.2);
}
.cell .div-content {
  -webkit-box-flex: 5;
  -ms-flex-positive: 5;
  flex-grow: 5;
  padding-left: 2px;
}
.cell .div-content[data-v-2a9d70bc],
.cell .input-content {
  margin-left: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.bottom-container .money-wrap .symbol {
  font-size: 14px;
  color: #e65c2e;
  font-weight: 700;
  font-family: HelveticaNeue-Bold, HelveticaNeue;
}
.bottom-container .money-wrap .money {
  font-size: 20px;
  color: #e65c2e;
  font-weight: 700;
  font-family: HelveticaNeue-Bold, HelveticaNeue;
}
.bottom-container .detail-wrap {
  margin: 2px 0 2px 8px;
}
.detail-wrap img {
  margin-left: 5px;
}
.bottom-container .detail-wrap .detail-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  font-family: PingFangSC-Regular, PingFang SC;
}
.bottom-container .detail-wrap > img {
  width: 14px;
  height: 14px;
  vertical-align: bottom;
  -webkit-transition: -webkit-transform 0.5s;
  transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
  transition: transform 0.5s, -webkit-transform 0.5s;
}
.submit-order {
  width: 160px;
  height: 40px;
  line-height: 40px;
  background: linear-gradient(133deg, #007aaa, #004e93);
  border-radius: 22px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  -webkit-box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  font-family: PingFangSC-Regular, PingFang SC;
}

.add-more {
  width: 160px;
  height: 40px;
  background: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 122, 170, 0.2);
  box-shadow: 0 0 8px 0 rgba(0, 122, 170, 0.2);
  border-radius: 22px;
  border: 1px solid #007aaa;
  font-size: 16px;
  line-height: 40px;
  position: relative;
  top: -8px;
  left: calc(50vw - 80px);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #007aaa;
  text-align: center;
}
.cell-area .cell .van-field,
.cell-area .cell-text-container .van-field {
  padding: 12px 0 !important;
}
.bottom-area {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #007aaa;
  text-align: center;
  width: 100%;
  height: 30px;
  font-size: 14px;
  line-height: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.cell-alive-title {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  height: 38px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000;
  line-height: 38px;
  position: relative;
  left: 12px;
  top: 0;
}
.cell-alive-list {
  margin: 0 14px;
  padding: 14px 0;
}
.cell-alive-list .van-field {
  padding: 12px 0 !important;
}
.cell-alive-list .van-field:not(:last-of-type) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
/* 功德经资卡片****************** */
.money-container {
  margin: 16px 12px 0;
  background-color: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 16px 12px 8px;
}
.money-container .money-title {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Medium, PingFang SC;
  display: inline-block;
  z-index: 2;
}
.price-type {
  font-size: 14px;
  font-weight: 400;
  font-family: PingFangSC-Regular, PingFang SC;
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.6);
}
.money-container .money-select-block {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin-top: 8px;
  row-gap: 8px;
  grid-row-gap: 8px;
}
.money-container .money-select-block .money-item-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.money-container .money-select-block .money-item {
  font-size: 14px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin: 0 5px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 10px 0;
  text-align: center;
}
.money-container .cell {
  line-height: 48px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.money-container .cell .label {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  width: 60px;
}
.cell .buyer-info-input {
  font-size: 14px;
  color: #000;
  margin-left: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

/* 明细******** */
.detail-title {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Medium, PingFang SC;
}
.van-popup--bottom .cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 8px;
}
.van-popup--bottom .cell .title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  font-family: PingFangSC-Regular, PingFang SC;
}
.van-popup--bottom .cell .money {
  font-size: 14px;
  color: #000;
  margin-left: auto;
  font-family: PingFangSC-Regular, PingFang SC;
}
/* 底部容器样式 */
.bottom-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 72px;
  background-color: #fff;
  -webkit-box-shadow: inset 0 1px 0 0 #eee;
  box-shadow: inset 0 1px 0 0 #eee;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 32px;
}
/* 首页按钮 **********/
.btn-home {
  width: 44px;
  height: 44px;
  background: #fff;
  border: 1px solid #007aaa;
  border-radius: 22px;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: fixed;
  bottom: 106px;
  right: 15px;
  z-index: 999;
}
.img-home {
  width: 20px;
  height: 20px;
}
.text-home {
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #007aaa;
}
</style>